import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import HeroSection from "./components/HeroSection";
import TrustStrip from "./components/TrustStrip";
import WhatIsSection from "./components/WhatIsSection";
import ComparisonSection from "./components/ComparisonSection";
import CategoryCardGrid from "./components/CategoryCardGrid";
import BlogPreview from "./components/BlogPreview";
import TestimonialSection from "./components/TestimonialSection";
import CTASection from "./components/CTASection";

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <HeroSection />
        <TrustStrip />
        <WhatIsSection />
        <ComparisonSection />
        <CategoryCardGrid />
        <TestimonialSection />
        <BlogPreview />
        <CTASection />
      </main>
      <Footer />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@graph": [
              {
                "@type": "Organization",
                name: "itaobuy.cam",
                url: "https://itaobuy.cam/",
                logo: "https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/62f99c0415358bd5388d5ed1df9ac1ff.jpeg",
                description: "Your trusted gateway to curated China shopping spreadsheets. Compare agents, discover products, and shop smarter from Taobao, 1688, and Weidian.",
                sameAs: [
                  "https://kaspreadsheet.com"
                ]
              },
              {
                "@type": "WebSite",
                name: "itaobuy.cam",
                url: "https://itaobuy.cam/",
                description: "Discover the ultimate ItaobuySpreadsheet guide 2026. Compare China shopping agents, browse curated spreadsheets, and find the safest way to buy from Taobao, 1688, and Weidian.",
                inLanguage: "en-US"
              },
              {
                "@type": "WebPage",
                name: "Best ItaobuySpreadsheet 2026 — Smart China Shopping Guide",
                description: "Discover the ultimate ItaobuySpreadsheet guide 2026. Compare China shopping agents, browse curated spreadsheets for Shoes, Hoodies, T-Shirts, Jackets, and more. The safest way to buy from Taobao, 1688, and Weidian with verified agents and weekly updated data.",
                url: "https://itaobuy.cam/",
                inLanguage: "en-US",
                isPartOf: {
                  "@type": "WebSite",
                  name: "itaobuy.cam",
                  url: "https://itaobuy.cam/"
                }
              }
            ]
          }),
        }}
      />
    </>
  );
}